import { EncryptStorage } from 'encrypt-storage'
const LS_ENCRYPTION_KEY = 'Ebtkar_Mo7@medAtef17_Admin'

export const ls = new EncryptStorage(LS_ENCRYPTION_KEY, {})
